import { z } from 'zod';

import { MCPSavedProfileSchema, MCPServerSchema } from './mcp-config.schema';

export const UpdateMcpConfigSchema = z
  .object({
    serversById: z.record(z.string(), MCPServerSchema),
    savedProfilesByProvider: z.record(z.string(), MCPSavedProfileSchema),
  })
  .describe(
    'Update the full MCP configuration — servers and saved profiles. Proto shape is normalised by schema transforms.',
  );

export type UpdateMcpConfigPayload = z.infer<typeof UpdateMcpConfigSchema>;

export const UpsertMcpServerSchema = z
  .object({
    server: MCPServerSchema,
  })
  .describe('Upsert a single MCP server.');

export type UpsertMcpServerPayload = z.infer<typeof UpsertMcpServerSchema>;

export const DeleteMcpServerSchema = z
  .object({
    id: z.string(),
  })
  .describe('Delete a single MCP server by ID.');

export type DeleteMcpServerPayload = z.infer<typeof DeleteMcpServerSchema>;

export const UpsertMcpProfileSchema = z
  .object({
    profile: MCPSavedProfileSchema,
  })
  .describe('Upsert a single MCP saved profile.');

export type UpsertMcpProfilePayload = z.infer<typeof UpsertMcpProfileSchema>;

export const DeleteMcpProfileSchema = z
  .object({
    providerId: z.string(),
  })
  .describe('Delete a single MCP saved profile by provider ID.');

export type DeleteMcpProfilePayload = z.infer<typeof DeleteMcpProfileSchema>;
